import { useReducer } from 'react';

import { GlobalContext } from './GlobalContext';
import { GlobalState, RoomColors } from './Global.interface';
import { globalReducer } from './GlobalReducer';

const INITIAL_STATE: GlobalState = {
    isLoading: false,
    roomColors: {
        roomBreakColor: '',
        roomBusyColor: '',
        roomCleanColor: '',
        roomFreeColor: '',
        roomOverColor: '',
    },
    profile: {},
    titlePage: '',
    isLoggedIn: false,
};

interface props {
    children: JSX.Element | JSX.Element[];
}

export const GlobalProvider = ({ children }: props) => {
    const [globalState, dispatch] = useReducer(globalReducer, INITIAL_STATE);
    const setLoggedIn = (isLoggedIn: boolean) => {
        dispatch({ type: 'setLoggedIn', payload: isLoggedIn });
    };

    const setIsChangeAccount = (isChangeAccount: boolean) => {
        localStorage.setItem('is_change_account', `${isChangeAccount}`);
        dispatch({ type: 'setIsChangeAccount', payload: isChangeAccount });
    };

    const setLoading = (isLoading: boolean) => {
        dispatch({ type: 'setLoading', payload: isLoading });
    };

    const setRoomColors = (data: RoomColors) => {
        dispatch({ type: 'setRoomColors', payload: data });
    };

    const setProfile = (value: any) => {
        dispatch({ type: 'setProfile', payload: value });
    };

    const setTitlePage = (value: any) => {
        dispatch({ type: 'setTitlePage', payload: value });
    };

    return (
        <GlobalContext.Provider
            value={{
                globalState,
                setLoggedIn,
                setLoading,
                setRoomColors,
                setProfile,
                setTitlePage,
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
};
